import React, { useEffect } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import policyHero from '../assets/policy-hero.jpg';

const TermsOfServicePage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div>
      <Navbar />
     <div style={{
        backgroundImage: `url(${policyHero})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        marginTop: '80px',
        padding: '120px 20px',
        textAlign: 'center',
        color: 'white',
        position: 'relative'
      }}>
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.55)' }}></div>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h1 style={{ fontSize: '48px', fontWeight: '700', marginBottom: '16px' }}>Terms of Service</h1>
          <p style={{ fontSize: '18px' }}>Please read these terms carefully before using our AI solutions and services.</p>
          <p style={{ marginTop: '12px' }}>Home &bull; Terms of Service</p>
        </div>
      </div>

      {/* Terms of Service Content */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="bg-light rounded p-5">
                <div className="mb-4">
                  <p className="text-muted mb-2">Last updated: {new Date().toLocaleDateString()}</p>
                  <p className="lead">
                    Welcome to Tecnvirons AI Intelligence Solutions. These Terms of Service govern your use of our AI-powered solutions and services. By accessing or using our services, you agree to be bound by these terms.
                  </p>
                </div>

                {/* Section 1 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">1. Acceptance of Terms</h3>
                  <p>
                    By accessing and using Tecnvirons' AI solutions and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                  </p>
                </div>

                {/* Section 2 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">2. Description of Service</h3>
                  <p className="mb-3">Tecnvirons provides AI-powered solutions including but not limited to:</p>
                  <ul>
                    <li>Field Service Management systems</li>
                    <li>Smart applications and automation tools</li>
                    <li>AI consulting and implementation services</li>
                    <li>Custom AI solution development</li>
                    <li>Technical support and maintenance</li>
                  </ul>
                </div>

                {/* Section 3 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">3. User Responsibilities</h3>
                  <p className="mb-3">As a user of our services, you agree to:</p>
                  <ul>
                    <li>Provide accurate and complete information when required</li>
                    <li>Maintain the security of your account credentials</li>
                    <li>Use our services in compliance with applicable laws and regulations</li>
                    <li>Not attempt to gain unauthorized access to our systems</li>
                    <li>Not use our services for any illegal or unauthorized purpose</li>
                    <li>Respect intellectual property rights</li>
                  </ul>
                </div>

                {/* Section 4 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">4. Intellectual Property Rights</h3>
                  <p>
                    All content, features, and functionality of our services, including but not limited to text, graphics, logos, icons, images, audio clips, digital downloads, data compilations, and software, are the exclusive property of Tecnvirons and are protected by copyright, trademark, and other intellectual property laws.
                  </p>
                </div>

                {/* Section 5 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">5. Service Availability</h3>
                  <p className="mb-3">We strive to maintain high availability of our services, but we do not guarantee uninterrupted access. Our services may be temporarily unavailable due to:</p>
                  <ul>
                    <li>Scheduled maintenance</li>
                    <li>Technical difficulties</li>
                    <li>Circumstances beyond our control</li>
                    <li>Security-related issues</li>
                  </ul>
                </div>

                {/* Section 6 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">6. Payment Terms</h3>
                  <p className="mb-3">For paid services:</p>
                  <ul>
                    <li>Payment is due according to the agreed schedule</li>
                    <li>All fees are non-refundable unless otherwise specified</li>
                    <li>We reserve the right to suspend services for non-payment</li>
                    <li>Prices may change with 30 days' notice</li>
                  </ul>
                </div>

                {/* Section 7 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">7. Limitation of Liability</h3>
                  <p>
                    To the maximum extent permitted by law, Tecnvirons shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, use, goodwill, or other intangible losses.
                  </p>
                </div>

                {/* Section 8 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">8. Termination</h3>
                  <p>
                    We may terminate or suspend your access to our services immediately, without prior notice, for any reason, including but not limited to breach of these Terms. Upon termination, your right to use the services will cease immediately.
                  </p>
                </div>

                {/* Section 9 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">9. Governing Law</h3>
                  <p>
                    These Terms shall be interpreted and governed by the laws of India. Any disputes arising from these terms will be subject to the exclusive jurisdiction of the courts in India.
                  </p>
                </div>

                {/* Section 10 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">10. Changes to Terms</h3>
                  <p>
                    We reserve the right to modify these terms at any time. We will notify users of any changes by posting the new Terms of Service on this page. Your continued use of the service after such modifications constitutes acceptance of the updated terms.
                  </p>
                </div>

                <div className="mb-5">
  <h3 className="text-primary mb-3">11. SMS Services</h3>

  <p>
    Tecnvirons Marshal and Tecnvirons LLC may send alerts, notifications, and marketing promotions. By participating, you agree to receive recurring automated promotional and personalized marketing text messages from Tecnvirons Marshal / Tecnvirons LLC to the mobile number you provided.
  </p>

  <p>
    Message frequency varies. Message and data rates may apply.
  </p>

  <p>
    <strong>Opt-Out Instructions:</strong> Reply STOP to any message to opt out.
  </p>

  <p>
    <strong>Carrier Disclaimer:</strong> Supported carriers include AT&amp;T, T-Mobile, Verizon, Sprint, and other participating carriers. Tecnvirons Marshal or Tecnvirons LLC is not liable for delayed or undelivered messages.
  </p>

  <p>
    <strong>Privacy Policy &amp; Data Usage:</strong> We respect your privacy. We will only use the information you provide to transmit your text messages. See our Privacy Policy for more details.
    {" "}
    <a
     href="/tecnvirons-website/privacy-policy"
    >
      Privacy Policy
    </a>
  </p>
</div>
                {/* Section 11 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">12. Contact Information</h3>
                  <p className="mb-3">If you have any questions about these Terms of Service, please contact us:</p>
                  <div className="mb-3">
                    <p><strong>Email:</strong> <a href="mailto:ai@tecnvi-ai.com" className="text-primary">ai@tecnvi-ai.com</a></p>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <p><strong>USA:</strong><br />
                      <a href="tel:+13092269909" className="text-primary">+1 (309) 226-9909</a></p>
                      <p><strong>India:</strong><br />
                      <a href="tel:+919371159100" className="text-primary">+91 9371159100</a></p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>USA Headquarters</strong><br />
                      Tecnvirons LLC
                      2501 Chatham Rd, Suite R<br />
                      Springfield, Illinois 62704</p>
                      <p><strong>India Office</strong><br />
                      <strong>Address 1:</strong><br />
                      Tecnvirons Pvt Ltd
                      F-4, Angel Apartment<br />
                      Road 6, Kalyani Nagar
                      Pune 411006</p>
                    </div>
                  </div>
                </div>

                {/* Back to Top */}
                <div className="text-center">
                  <a href="#top" className="btn btn-primary py-2 px-4">
                    <i className="fa fa-arrow-up me-2"></i>Back to Top
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<Footer />
    </div>
  );
};

export default TermsOfServicePage;